<template>
    <Popper arrow hover open-delay="200" :placement="placement">
        <slot></slot>
        <template #content>
            <div class="text" v-html="text"></div>
        </template>
    </Popper>
</template>

<script lang="ts">
import Popper from 'vue3-popper'

export default {
    components: {
        Popper,
    },
    props: {
        text: {
            type: String,
            required: true,
        },
        placement: {
            type: String as PropType<
                | 'top'
                | 'bottom'
                | 'auto'
                | 'left'
                | 'right'
                | 'auto-start'
                | 'auto-end'
                | 'top-start'
                | 'top-end'
                | 'bottom-start'
                | 'bottom-end'
                | 'right-start'
                | 'right-end'
                | 'left-start'
                | 'left-end'
            >,
            default: 'bottom',
        },
    },
    data() {
        return {
            popupLoaded: false,
        }
    },
}
</script>

<style scoped>
.text {
    padding: 10px 10px 10px 15px;
}
</style>
